module.exports = __webpack_public_path__ + "img/managers-active.5a66e024.svg";